import { render } from "./cate.vue?vue&type=template&id=48828e65"
import script from "./cate.vue?vue&type=script&lang=js"
export * from "./cate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__